import { Button } from "@progress/kendo-react-buttons";

import { useTranslation } from "react-i18next";
import Spinner from "../loader/ButtonSpinner";
import type { ReactNode } from "react";

interface GxApplyMdButtonProps {
  label?: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  loadingLabel?: string;
}



const GxApplyButtonMd: React.FC<GxApplyMdButtonProps> = ({
  onClick,
  label = "Apply",
  children,
  loading = false,
  disabled = false,
  loadingLabel,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      className="gx-drawer-save-button-md gx-submit-for-approval-small"
    >
      {loading && (
        <Spinner/>
   
      )}
         {/* {label} */}
      <span className="gx-h4-b">{label}</span>
    </Button>
  );
};
export default GxApplyButtonMd;
